import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("user", ["auth"])
  },
  methods: {
    CheckUserPermission(permitted) {
      return permitted.some(role => role === this.auth.user.role);
    },
    CheckUserPermissionById(permitted) {
      return permitted.some(id => id === this.auth.user.id);
    }
  }
};
